
import Paginate from './../../utils/Paginate';
import { FormatMoney } from './../../utils/formatMoney';
import ScheduledServices from '../../services/ScheduledServices';
import { convert, DisplayCurrentTime, formatDate } from './../../utils/convertDate';

export const ScheduledTransferTable = ({ pageIndex, transfers, pageNumber, nextPage, setPageIndex, search, prevPage, totalPage, status, fromm, pageLength, too, type, ScheduledServices, setTransfer }) => {

    const statusStyles = {
        Success: 'bg-green-500 text-white',
        Pending: 'bg-amber-400 text-white',
        Failed: 'bg-orange-600 text-white',
    }


    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }
    return (
        <>
            <div className="mt-8 flex flex-col">
                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">

                            <table className="min-w-full table-fixed divide-y divide-gray-300">
                                <thead>
                                    <tr>

                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400 ">
                                            Account Name
                                        </th>
                                        <th scope="col" className=" py-3.5 text-left text-sm italic font-normal text-gray-400">
                                            Amount
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                            Receiver's Name
                                        </th>
                                        <th scope="col" className=" py-3.5 min-w-[12rem]  text-left text-sm italic font-normal text-gray-400">
                                            Receiver's Account Number
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                            Start Date
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                            End Date
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 min-w-[10rem] text-left text-sm italic font-normal text-gray-400">
                                            Next Scheduled Date
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 min-w-[9rem] text-left text-sm italic font-normal text-gray-400">
                                            Scheduled Status
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                            Duration
                                        </th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                            Narration
                                        </th>

                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">

                                        </th>

                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                            <span className="sr-only">Edit</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 bg-white">
                                    {transfers.map((person, i) => (
                                        <tr key={i} className="bg-gray-50">
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.sourceAccountName}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{FormatMoney(person.amount)}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.destinationAccountName}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.destinationAccountNumber}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatDate(person.startDate)}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatDate(person.endDate)}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatDate(person.nextDebitDate)}</td>
                                            <td><span className={classNames(
                                                statusStyles[person.scheduleStatus], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}> {person.scheduleStatus}</span></td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.frequency}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.narration}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
        </>
    )
}